import { render, staticRenderFns } from "./BlockInfo.vue?vue&type=template&id=7e08b744&scoped=true"
import script from "@/components/request/RequestDetail/block-info/BlockInfo.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDetail/block-info/BlockInfo.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDetail/block-info/block-info.scss?vue&type=style&index=0&id=7e08b744&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e08b744",
  null
  
)

export default component.exports